// extracted by mini-css-extract-plugin
export default {"melodyVideo":"BO-z","isFullWidth":"CO-z","landingPageVideo":"DO-z","play":"EO-z","iframeVideo":"FO-z","playHidden":"GO-z","fullwidth":"HO-z"};